import { isPermitted } from 'utils/permissions'
import { developLinks, deployLinks, trainLinks, operateLinks, profileLinks, securityLinks, accountLinks, moreLinks } from './constants'
import slugify from 'react-slugify'

export const settingsPageChek = (router) => {
  return router.location.pathname.includes('/settings') ||
    router.location.pathname.includes('/location') ||
    router.location.pathname.includes('/marketplace') ||
    router.location.pathname.includes('/solution') ||
    router.location.pathname.includes('/authentication') ||
    router.location.pathname.includes('/partner')
}

export const getWorkspaceIconText = (name) => {
  if (!name) return ''

  const rawName = (name || '').toString().trim()
  if (!rawName) return ''

  const words = rawName.split(/\s+/).filter(Boolean)
  if (words.length >= 2) {
    return `${words[0][0] || ''}${words[1][0] || ''}`.toUpperCase()
  }

  const one = words[0] || ''
  return one.slice(0, 2).toUpperCase()
}

export const getOpenIds = ({ items, ids }) => {
  const updateItems = items.filter((item) => !ids.includes(item.id)).map((item) => item.id)
  return updateItems
}

export const filterWorkspaces = (workspaces, workspace, onSelectWorkspace) => {
  if (!workspaces) return []

  const mapList = workspaces.map((ws) => ({
    hasPermissions: true,
    type: 'rowicon',
    image: ws.logo,
    iconText: !ws.logo && getWorkspaceIconText(ws.name || ws.organizationName),
    isLight: !ws.logo,
    label: ws.name || ws.organizationName,
    caption: ws.id === workspace?.id ? 'Current' : ws.userRole,
    style: 'border',
    onClick: () => onSelectWorkspace(ws.subDomain)
  }))

  return mapList
}

export const toggleSection = ({ id, menuIds, storageKey, callback }) => {
  let updateOpenSections = []
  if (menuIds.includes(id)) {
    updateOpenSections = menuIds.filter((item) => item !== id)
  } else {
    updateOpenSections = [...menuIds, id]
  }
  saveCloseIds({ ids: updateOpenSections, storageKey, callback })
}

export const expandAll = ({ value, menu, storageKey, callback, customParams }) => {
  const closeValue = value === 'all' ? [] : menu.map(item => item.id)
  saveCloseIds({ ids: closeValue, storageKey, callback })
  if (customParams) {
    const { customSections, customKey, customCallback } = customParams
    const customValue = value === 'all' ? [] : customSections.map(item => item.id)
    saveCloseIds({ ids: customValue, storageKey: customKey, callback: customCallback })
  }
}

export const saveCloseIds = ({ ids, storageKey, callback }) => {
  localStorage.setItem(storageKey, JSON.stringify(ids))
  callback && callback(ids)
}

export const filterMenuItems = (
  items, detailRole, workspace, pendingDevices
) => {
  const checkPermissions = (item) => isPermitted(item, detailRole, workspace)
  const mapItems = items.filter((item) => checkPermissions(item)).map((item) => {
    let badge = item.badge
    if (item.id === 'devices-enrollment' && !!pendingDevices.length) {
      badge = {
        color: item.color,
        text: pendingDevices.length || 0
      }
    }
    return {
      ...item,
      to: item.to ? `/${workspace && slugify(workspace.name)}${item.to}` : undefined,
      badge,
      hasPermissions: true
    }
  })
  return mapItems
}

export const mapMenuItems = ({
  detailRole, workspace, pendingDevices
}) => {
  const filterTrainLinks = filterMenuItems(trainLinks, detailRole, workspace)
  const filterDevelopLinks = filterMenuItems(developLinks, detailRole, workspace)
  const filterDeployLinks = filterMenuItems(deployLinks, detailRole, workspace, pendingDevices)
  const filterOperateLinks = filterMenuItems(operateLinks, detailRole, workspace)


  const mapTrainLinks = {
    id: 'train',
    header: 'Train',
    hasPermissions: filterTrainLinks.length > 0,
    actions: filterTrainLinks
  }

  const mapDevelopLinks = {
    id: 'develop',
    header: 'Develop',
    hasPermissions: filterDevelopLinks.length > 0,
    actions: filterDevelopLinks
  }

  const mapDeployLinks = {
    id: 'deploy',
    header: 'Deploy',
    hasPermissions: filterDeployLinks.length > 0,
    actions: filterDeployLinks
  }

  const mapOperateLinks = {
    id: 'operate',
    header: 'Operate',
    hasPermissions: filterOperateLinks.length > 0,
    actions: filterOperateLinks
  }

  return [
    mapTrainLinks,
    mapDevelopLinks,
    mapDeployLinks,
    mapOperateLinks,
  ]
}

export const mapMenuSettings = ({
  detailRole, workspace, vendor
}) => {
  const filterProfileLinks = filterMenuItems(profileLinks, detailRole, workspace)
  const filterSecurityLinks = filterMenuItems(securityLinks, detailRole, workspace)
  const filterAccountLinks = filterMenuItems(accountLinks, detailRole, workspace)
  const filterMoreLinks = filterMenuItems(moreLinks, detailRole, workspace).filter((item) => {
    if (item.id === 'partner' && (!vendor.details || vendor.details && vendor.details.status === 'inactive')) {
      return false
    }
    return item
  })

  const mapProfileLinks = {
    id: 'profile',
    header: 'Profile',
    hasPermissions: filterProfileLinks.length > 0,
    actions: filterProfileLinks
  }

  const mapSecurityLinks = {
    id: 'security',
    header: 'Security',
    hasPermissions: filterSecurityLinks.length > 0,
    actions: filterSecurityLinks
  }

  const mapAccountLinks = {
    id: 'account',
    header: 'Account',
    hasPermissions: filterAccountLinks.length > 0,
    actions: filterAccountLinks
  }

  const mapMoreLinks = {
    id: 'more',
    header: 'More',
    hasPermissions: filterMoreLinks.length > 0,
    actions: filterMoreLinks
  }

  return [
    mapProfileLinks,
    mapSecurityLinks,
    mapAccountLinks,
    mapMoreLinks
  ]
}

export const loadSavedSectionStorage = (storageId) => {
  const getSavedIds = localStorage.getItem(storageId)
  const parseIds = getSavedIds ? JSON.parse(getSavedIds) : []
  return parseIds
}

export const getDisplayUserName = (user) => {
  const fullName = user.firstName ? `${user.firstName.trim() || ''} ${user.lastName.trim() || ''}` : ''
  const displayName = (fullName && fullName.trim()) || user.email || '-'
  return displayName
}